"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Error = _styledComponents.default.div.withConfig({
  displayName: "InputError__Error",
  componentId: "q56n5p-0"
})(["font-size:14px;color:", ";padding:8px 16px;"], p => p.theme.colors.err);

var _default = Error;
exports.default = _default;